import type { CursorPagination, CursorPaginationParams } from './base'

export interface Store {
  storeName: string
  storeOrgNumber: string
  storeID: string
  storePhone: string
  storeAddress: string
  storeEmail: string
  orgID?: string
}

export type TypeStoreStatus = 'Active' | 'Inactive' | 'Blacklisted'
export enum EnumStoreStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Blacklisted = 'Blacklisted',
}

export interface Stores {
  userID?: string
  roleID?: string
  orgID?: string
  storeID?: string
  storeName?: string
  storeWebSite?: string
  storeVatNumber?: string
  storeFSkatt?: boolean
  storeOrgNumber?: string
  storeStatus?: TypeStoreStatus
  storeEmail?: string
  storePhone?: string
  storeAddress?: string
  storeZipCode?: string
  storeCity?: string
  storeCountry?: string
  storeDescription?: string
  storeContactPerson?: string
  storeMaxUsers?: number
  currency?: string
  storeAllowCarAPI?: boolean
  storeAllowSendSMS?: boolean
  storeSendSMS?: boolean
  storeUsesCheckin?: boolean
  storeUsesPIN?: boolean
  storePaymentOptions?: StorePaymentOptions
}

export interface StorePaymentOptions {
  bankgiro?: string
  plusgiro?: string
  paymentdays?: number
  /** Default påminnelseavgift prefilled on reminder invoices, in store currency. */
  reminderFee?: number
}

/** What the store form submits: store fields plus the payment options flattened in. */
export type StoreUpdatePayload = Partial<Stores> &
  Omit<StorePaymentOptions, 'bankgiro' | 'plusgiro'> & {
    bankgiro?: string
    plusgiro?: string
  }

export interface StoreListParams extends CursorPaginationParams {
  orgID?: string
}

export interface StoresData extends CursorPagination {
  stores: Stores[]
}

export interface StoreData extends CursorPagination {
  store: Stores
  /** The backend returns a store's payment options as a sibling array (zero or one entry). */
  storePaymentOptions?: StorePaymentOptions[]
}
